import React, { useEffect } from 'react';
import { useTheme } from '../../../assets/contexts/ThemeContext';
import CustomSelect from '../../../components/widgets/CustomSelect';

/**
 * 배너 타입 제어 컴포넌트
 * 원본: banner-type-control.html
 */
const BannerTypeControl = () => {
  const themeContext = useTheme();

  // 배너 타입 변경 시 배너 컨테이너 업데이트
  // React Hooks 규칙: 모든 hooks는 조건부 return 전에 호출되어야 함
  useEffect(() => {
    if (!themeContext) return;

    // 배너 컨테이너 찾기 및 업데이트
    const updateBannerContainer = () => {
      const container = document.getElementById('banner-container');
      if (!container) {
        // 배너 컨테이너가 아직 없으면 잠시 후 다시 시도
        requestAnimationFrame(updateBannerContainer);
        return;
      }

      // React 컴포넌트가 이미 렌더링되어 있으므로,
      // ThemeContext의 bannerType 변경만으로 자동 업데이트됨
      // 여기서는 추가 작업 불필요
    };

    updateBannerContainer();
  }, [themeContext, themeContext?.themeConfig?.bannerType]);

  if (!themeContext) return null;
  const { themeConfig, set } = themeContext;

  const handleChange = (selectedType) => {
    set('bannerType', selectedType);
  };

  const handleHelpMouseOver = (e) => {
    e.currentTarget.style.backgroundColor = '#f5f5f5';
    e.currentTarget.style.borderColor = 'var(--theme-color-primary)';
    e.currentTarget.style.color = 'var(--theme-color-primary)';
  };

  const handleHelpMouseOut = (e) => {
    e.currentTarget.style.backgroundColor = 'transparent';
    e.currentTarget.style.borderColor = '#ddd';
    e.currentTarget.style.color = '#666';
  };

  return (
    <>
      <style>
        {`
          #banner-type-control-section:not(:last-child) {
            padding-bottom: 15px;
          }
          #banner-type-control-section > div {
            display: flex;
            align-items: center;
            gap: 6px;
            margin-bottom: 8px;
          }
          #banner-type-control-section > div > label {
            display: block;
            font-weight: bold;
            color: #333;
            font-size: 13px;
            cursor: default;
            margin: 0;
            flex: 1;
          }
          #banner-type-control-section .theme-help-btn {
            background: transparent;
            border: 1px solid #ddd;
            color: #666;
            font-size: 11px;
            width: 20px;
            height: 20px;
            padding: 0;
            border-radius: 50%;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.2s;
            flex-shrink: 0;
          }
          #banner-type-selector {
            padding: 8px 12px;
            border: 1px solid #ddd;
            border-radius: 4px;
            font-size: 13px;
            width: 100%;
            background: white;
            cursor: pointer;
          }
        `}
      </style>
      <div id="banner-type-control-section">
        <div>
          <label htmlFor="banner-type-selector">📋 상단 제목 배너:</label>
          <button
            type="button"
            className="theme-help-btn"
            data-target="banner-type-control-section"
            title="이 항목으로 이동"
            onMouseOver={handleHelpMouseOver}
            onMouseOut={handleHelpMouseOut}
          >
            ?
          </button>
        </div>
        <CustomSelect
          inputId="banner-type-selector"
          value={themeConfig.bannerType || 'center-image-dynamic'}
          onChange={handleChange}
          isSearchable={false}
          isClearable={false}
          options={[
            { value: 'center-image-dynamic', label: '0) Urdan 기본 스타일(center-image-dynamic)' },
            { value: 'banner-simple', label: '1) 이미지 없는 심플 배너(banner-simple)' },
            { value: 'banner-card', label: '2) 카드형 배너 스타일(banner-card)' },
            { value: 'banner-icon', label: '3) 아이콘 포함된 배너(banner-icon)' },
            { value: 'banner-fullscreen', label: '4) 풀스크린 배경이미지 배너(banner-fullscreen)' },
            { value: 'banner-minimal', label: '5) 심플 모던 배너(banner-minimal)' },
            { value: 'banner-glass', label: '6) 리퀴드 글래스 배너(banner-glass)' },
          ]}
          styles={{
            control: (base, state) => ({
              ...base,
              width: '100%',
              minHeight: 36,
              fontSize: 13,
              borderRadius: 4,
              borderColor: state.isFocused ? '#86b7fe' : '#ddd',
            }),
            valueContainer: (base) => ({ ...base, padding: '0 12px' }),
            indicatorsContainer: (base) => ({ ...base, height: 36 }),
          }}
        />
      </div>
    </>
  );
};

export default BannerTypeControl;

